<template lang="html">
    <div class="view-home">

        <div class="block-company">
            <div class="block-company-content">
                <div class="block-company-gradient"></div>
                <div
                    v-if="userSite"
                    class="block-company-text">
                    <h1>{{ userSite.facility_name }}</h1>
                    <h2>{{ userSite.company_name }}</h2>
                </div>
            </div>
        </div>

        <!-- <NavBar /> -->

        <div class="layout-width padding">
            <el-row
                :gutter="20">
                <el-col
                    :sm="24">
                    <HomeTile
                        :info="infoSite"
                        title="Mon site"
                        subtitle="la liste des moteurs présents sur mon site"
                        icon="industry"
                        route="Motors">
                    </HomeTile>
                </el-col>
                <el-col
                    :xs="24"
                    :sm="16">
                    <HomeTile
                        :info="infoSelection"
                        :routeParams="{auditUid: currentAudit.uid}"
                        title="Ma sélection"
                        subtitle="ma liste de moteurs à auditer"
                        icon="clipboard-list"
                        route="Selection">
                    </HomeTile>
                </el-col>
                <el-col
                    :xs="24"
                    :sm="8">
                    <HomeTile
                        :info="infoStatus"
                        title="Suivi"
                        subtitle="de mon audit"
                        icon="check-circle"
                        route="Status">
                    </HomeTile>
                </el-col>
            </el-row>
        </div>

        <div class="layout-width">
            <div class="home-subnav">
                <el-tooltip
                    content="Veuillez sélectionné un ou plusieurs moteurs"
                    placement="left"
                    effect="dark"
                    :disabled="selectedMotors.length > 0"
                >
                    <span class="el-button el-button--text btn-download-motor-file">
                        <el-button
                            type="primary"
                            class=""
                            :disabled="selectedMotors.length === 0"
                            @click="requestMotorSelecedFile"
                        >télécharger ma sélection</el-button>
                    </span>
                </el-tooltip>
                <br>
                <router-link
                    :to="{ name: 'Help' }">
                    <el-button
                        round
                        icon="el-icon-info">
                        Comment ça marche ?
                    </el-button>
                </router-link>
            </div>
        </div>
        <waiting-modal
            ref="waiting-modal"
            loading-text="Generating file"
            :onSuccess="downloadFile"
        ></waiting-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import NavBar from '@/components/ui/NavBar';
import HomeTile from './HomeTile';
import WaitingModal from '../../partials/WaitingModal';
export default {
    name: 'Home',
    components: {
        // NavBar,
        HomeTile,
        WaitingModal
    },
    data (){
        return {
            verboseStatus: {
                'VALIDATED': 'VALIDÉ',
                'PREPARED': 'PRÉPARÉ',
                'SHIPPED': 'EXPÉDIÉ',
                'AUDITED': 'AUDITÉ',
                'RECEIVED': 'REÇU',
                'PENDING': 'EN ATTENTE',
            }
        };
    },
    computed: {
        ...mapGetters([
            'motor',
            'site',
            'audit',
            'currentUser',
            'siteRelatedMotors',
            'auditSelectedMotorsUids'
        ]),
        currentAudit () {
            return this.audit[0];
        },
        userSite () {
            let site = this.site.find(s => s.customer_uid === this.currentUser.uid);
            this.$store.commit('SET_CURRENT_SITE', site)
            return site
        },
        infoSite () {
            const plural = this.siteRelatedMotors.length > 1 ? 's' : '';
            return this.siteRelatedMotors.length ? this.siteRelatedMotors.length + ' moteur' + plural + ' enregistré' + plural : 'Aucun moteur enregistré';
        },
        selectedMotors (){
            let selectedMotorsUids = this.auditSelectedMotorsUids(this.currentAudit)
            return this.siteRelatedMotors.filter(m => selectedMotorsUids.includes(m.uid));
        },
        infoSelection () {
            const selectionLength = this.selectedMotors.length;
            const plural = selectionLength > 1 ? 's' : '';
            return selectionLength ? selectionLength + ' moteur' + plural + ' sélectionné' + plural : 'Aucun moteur sélectionné';
        },
        infoStatus () {
            let status = 'En attente';
            if(this.currentAudit && this.currentAudit.status){
                status = this.verboseStatus[this.currentAudit.status];
            }
            return status;
        }
    },
    methods: {
        requestMotorSelecedFile (){
            var site = this.userSite ? this.userSite : this.site[0]
            this.$refs['waiting-modal'].open();
            this.$store.dispatch('createItem', {
                item: {
                    motors_uid: this.motor.map((motor) => motor.uid),
                    status: 'PENDING',
                    site_uid: site.uid,
                },
                model: 'generateFileRequest',
                url: this.$store.state.api.meta.listModels.generateFileRequest.url,
            }).then((res) => {
                this.$refs['waiting-modal'].watchRequestStatus(res.url);
            }).catch((e) => {
                this.$refs['waiting-modal'].displayError();
            },)
        },
        downloadFile (response) {
            var element = document.createElement('a');
            element.setAttribute('href', response.data.xlsx_file);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    },
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables';

.block-company {
    position: relative;
    background: $--color-primary;
    background: url('../../../../static/images/shounen21-778549-unsplash.jpg') no-repeat center center;
    background-size: cover;
    color: white;
    h1 {
        font-size: 40px;
        line-height: 40px;
        margin-bottom: 0;
    }
    h2 {
        font-size: 20px;
        line-height: 20px;
        text-transform: uppercase;
    }
    .block-company-text {
        display: block;
        position: relative;
        max-width: $layout-width;
        margin: auto;
        padding: 0 20px;
    }
    .block-company-content {
        display: block;
        position: relative;
        padding: 80px 0 20px;
    }
    .block-company-gradient {
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        background: linear-gradient(to bottom, rgba(#000,0) 0%,rgba(#000,0.3) 100%);
    }
}

.price-box {
    h3 {
        text-align: center;
        font-size: 30px;
        line-height: 30px;
        padding: 20px 0 30px;
        .mwh-unit {
            font-size: 12px;
            vertical-align: super;
        }
    }
}

.description-list {
    margin: 0;
    dt {
        font-size: 12px;
        color: #ccc;
    }
    dd {
        margin: 0;
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    a {
        color: $--color-primary;
    }
}

.view-home {
    .home-subnav {
        padding: 20px;
        padding-top: 0;
        .el-tooltip.el-button.el-button--text{
            padding: 0;
        }
    }
    .btn-download-motor-file{
        margin-bottom: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/DefaultHome.vue